import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthData } from '../../Utils/storage';

const RouteGuard = ({children}) => {
  if (!getAuthData()) {
    return <Navigate to="/login-email" replace />
  }
  return children
};
 
export default RouteGuard;
